// Chakra imports
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
// Custom components
import Card from 'components/card/Card';
import PieChart from 'components/charts/PieChart';
import { pieChartOptions } from 'variables/charts';
import { VSeparator } from 'components/separator/Separator';

const HEALTH_COLORS = [ '#4318FF', '#6AD2FF', '#EE5D50' ];
const HEALTH_LABELS = [ 'Plus de 50 % restant', '10 à 50 % restant', 'Moins de 10 %' ];

// État des forfaits horaires actifs selon la part d'heures restante
export default function ForfaitsHealth(props: {
	healthy: number;
	watch: number;
	critical: number;
	[x: string]: any;
}) {
	const { healthy, watch, critical, ...rest } = props;

	// Chakra Color Mode
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const cardColor = useColorModeValue('white', 'navy.700');
	const cardShadow = useColorModeValue('0px 18px 40px rgba(112, 144, 176, 0.12)', 'unset');

	const counts = [ healthy, watch, critical ];
	const total = healthy + watch + critical;
	const chartOptions = {
		...pieChartOptions,
		labels: HEALTH_LABELS,
		colors: HEALTH_COLORS,
		fill: { ...pieChartOptions.fill, colors: HEALTH_COLORS }
	};

	return (
		<Card p='20px' alignItems='center' flexDirection='column' w='100%' {...rest}>
			<Flex
				px={{ base: '0px', '2xl': '10px' }}
				justifyContent='space-between'
				alignItems='center'
				w='100%'
				mb='8px'>
				<Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
					État des forfaits horaires
				</Text>
				<Text color='secondaryGray.600' fontSize='sm' fontWeight='500' mt='4px'>
					{total} actif(s)
				</Text>
			</Flex>

			{total > 0 ? (
				<PieChart h='100%' w='100%' chartData={counts} chartOptions={chartOptions} />
			) : (
				<Text color='secondaryGray.600' fontSize='sm' my='auto'>
					Aucun forfait horaire actif
				</Text>
			)}
			<Card
				bg={cardColor}
				flexDirection='row'
				justifyContent='space-between'
				boxShadow={cardShadow}
				w='100%'
				p='15px'
				px='20px'
				mt='15px'
				mx='auto'>
				{counts.map((count, index) => (
					<Flex key={HEALTH_LABELS[index]}>
						{index > 0 && <VSeparator mx='12px' />}
						<Flex direction='column' py='5px'>
							<Flex align='center'>
								<Box h='8px' w='8px' bg={HEALTH_COLORS[index]} borderRadius='50%' me='4px' flexShrink={0} />
								<Text fontSize='xs' color='secondaryGray.600' fontWeight='700' mb='5px'>
									{HEALTH_LABELS[index]}
								</Text>
							</Flex>
							<Text fontSize='lg' color={textColor} fontWeight='700'>
								{count}
							</Text>
						</Flex>
					</Flex>
				))}
			</Card>
		</Card>
	);
}
